(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name summary.controller:SummaryCtrl
   *
   * @description
   *
   */
  angular
    .module('summary')
    .controller('SummaryCtrl', SummaryCtrl);

  SummaryCtrl.$inject = ['$location', 'DataService', '$log', '$window', 'moment', '$uibModal', 'FileSaver'];

  function SummaryCtrl($location, dataService, $log, $window, moment, $uibModal, fileSaver) {
    var vm = this;
    vm.ctrlName = 'SummaryCtrl';
    vm.data = dataService.data;
    vm.quoteTypeName = quoteTypeName;
    vm.print = print;
    vm.downloadQuotePdf = downloadQuotePdf;
    vm.moment = moment;
    vm.openContactModal = openContactModal;
    vm.openEmailModal = openEmailModal;
    vm.getSbuWebsite = dataService.getSbuWebsite;
    vm.downloadInProgress = false;
    vm.showEmailButton = showEmailButton;
    vm.showDownloadButton = showDownloadButton;

    activate();

    function activate() {
      if (angular.isUndefined(vm.data.quoteResponse)) {
        $log.debug('No summary response to work with, redirect to quote form.');
        $location.path('/quote');
      }
      if (angular.isUndefined(vm.data.selectedBroker)) {
        $log.debug('No broker selected, redirect to broker selection.');
        $location.path('/broker');
      }
    }

    function quoteTypeName() {
      return dataService.getQuoteType(vm.data.quoteRequest.quoteType).name;
    }

    function print() {
      $window.print();
    }

    function downloadQuotePdf() {
      vm.downloadInProgress = true;
      dataService.downloadQuotePdf().then(function (result) {
        var pdfBlob = dataService.base64StringToBlob(result.data.quotePdf, 'application/pdf');
        fileSaver.saveAs(pdfBlob, result.data.quoteFileName);
        vm.downloadInProgress = false;
      });
    }

    function openContactModal() {
      var modalInstance = $uibModal.open({
        templateUrl: 'summary/views/summary-contact-modal.tpl.html',
        controller: 'SummaryContactModalCtrl',
        controllerAs: 'summaryContactModal',
        bindToController: true
        });
        modalInstance.result.then(function () {
        }, function () {
          $log.debug('Modal dismissed at: ' + new Date());
        });
    }

    function openEmailModal() {
      var emailModalInstance = $uibModal.open({
        templateUrl: 'summary/views/summary-email-modal.tpl.html',
        controller: 'SummaryEmailModalCtrl',
        controllerAs: 'summaryEmailModal',
        bindToController: true
      });
      emailModalInstance.result.then(function () {
      }, function () {
        $log.debug('Email modal dismissed at: ' + new Date());
      });
    }

    function showEmailButton() {
      return vm.data.quoteDefinition ? vm.data.quoteDefinition.screenOptions.downloadQuoteButtonEnabled === 'true' : false;
    }

    function showDownloadButton() {
      return vm.data.quoteDefinition ? vm.data.quoteDefinition.screenOptions.emailQuoteButtonEnabled === 'true' : false;
    }
  }
}());
